import { observer } from 'mobx-react-lite';
import DigitalHumanStore from '@/stores/digital-human-store';

interface KeywordOverlayProps {
  store: DigitalHumanStore;
}

export const KeywordOverlay = observer(({ store }: KeywordOverlayProps) => {
  if (!store.keywordsVisible || store.keywords.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-x-0 bottom-[7.5rem] z-[85] flex flex-wrap justify-center gap-5 px-8">
      {store.keywords.map((keyword, index) => (
        <span key={`${keyword}-${index}`} className="flex items-center gap-5">
          <span
            className="text-4xl font-bold tracking-wide text-white drop-shadow-[0_0_14px_rgba(139,92,246,0.85)] md:text-5xl"
            style={{
              animation: `keyword-pulse 1.2s ease-in-out ${index * 0.18}s both`
            }}
          >
            {keyword}
          </span>
          {index < store.keywords.length - 1 && (
            <span
              className="text-2xl font-bold text-violet-400/70 md:text-3xl"
              style={{
                animation: `keyword-pulse 1.2s ease-in-out ${index * 0.18 + 0.09}s both`
              }}
            >
              ·
            </span>
          )}
        </span>
      ))}
    </div>
  );
});
